export * from './src/social-groups-v2-group-groups.meta.js';
